(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9721],{

/***/ 70385:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const prisma = __webpack_require__(22804)

module.exports = prisma


/***/ }),

/***/ 62992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgGithub = function SvgGithub(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-prefix": "fab",
    "data-icon": "github",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    style: {
      fill: "currentColor"
    }
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgGithub);

/***/ }),

/***/ 96724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-35.2 -41.333 305.067 248"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M229.763 25.817c-2.699-10.162-10.65-18.165-20.747-20.881C190.716 0 117.333 0 117.333 0S43.951 0 25.651 4.936C15.554 7.652 7.602 15.655 4.904 25.817 0 44.237 0 82.667 0 82.667s0 38.43 4.904 56.85c2.698 10.162 10.65 18.164 20.747 20.881 18.3 4.935 91.682 4.935 91.682 4.935s73.383 0 91.683-4.935c10.097-2.717 18.048-10.72 20.747-20.88 4.904-18.422 4.904-56.851 4.904-56.851s0-38.43-4.904-56.85",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m93.333 117.558 61.334-34.89-61.334-34.893z",
    fill: "#fff"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgYoutube);

/***/ }),

/***/ 57824:
/***/ (function(module) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}


/***/ }),

/***/ 93181:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/[slug]",
      function () {
        return __webpack_require__(74318);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/babel-plugin-superjson-next/tools.js
var tools = __webpack_require__(23544);
// EXTERNAL MODULE: ./components/Layout/Layout.tsx + 22 modules
var Layout = __webpack_require__(4828);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/ms/index.js
var ms = __webpack_require__(57824);
var ms_default = /*#__PURE__*/__webpack_require__.n(ms);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./public/social-icons/twitter.svg
var twitter = __webpack_require__(66871);
// EXTERNAL MODULE: ./public/social-icons/linkedin.svg
var linkedin = __webpack_require__(43441);
// EXTERNAL MODULE: ./public/social-icons/github.svg
var github = __webpack_require__(62992);
// EXTERNAL MODULE: ./public/social-icons/instagram.svg
var instagram = __webpack_require__(57620);
// EXTERNAL MODULE: ./public/social-icons/youtube.svg
var youtube = __webpack_require__(96724);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/JobPost/JobPostPreview.tsx + 2 modules
var JobPostPreview = __webpack_require__(87938);
// EXTERNAL MODULE: ./utils/enumToLabel/organisationSizeToLabel.ts
var organisationSizeToLabel = __webpack_require__(54840);
;// CONCATENATED MODULE: ./components/JsonLd/OrganizationJsonLd.tsx

const OrganizationJsonLd = (param)=>{
    let { organisation  } = param;
    // Return early if no organisation.
    if (!organisation) return null;
    // Put it all together.
    const jsonLD = {
        "@context": "http://schema.org",
        "@type": "Organization",
        name: organisation.name,
        url: "".concat(organisation.webUrl)
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(jsonLD)
        }
    });
};

;// CONCATENATED MODULE: ./pages/company/[slug]/index.tsx















function OrganisationPage(param) {
    let { organisation , activeJobPosts , expiredJobPosts  } = param;
    var ref, ref1;
    const pageTitle = organisation ? "".concat(organisation.name, " Careers") : "Not Found.";
    const metaDescription = "Find the latest ".concat(organisation === null || organisation === void 0 ? void 0 : organisation.name, " jobs with JavaScript. Apply for ").concat(organisation === null || organisation === void 0 ? void 0 : organisation.name, " jobs.");
    // If no organisation, redirect to home page after a short delay.
    (0,react.useEffect)(()=>{
        if (!organisation) {
            const timer = setTimeout(()=>router_default().push("/"), ms_default()("10s"));
            return ()=>{
                clearTimeout(timer);
            };
        }
    }, []);
    const orgName = (organisation === null || organisation === void 0 ? void 0 : organisation.name) || (organisation === null || organisation === void 0 ? void 0 : (ref = organisation.webUrl) === null || ref === void 0 ? void 0 : ref.replace("https://", ""));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* Layout */.A, {
        pageTitle: pageTitle,
        metaDescription: metaDescription,
        canonicalUrl: "/company/".concat(organisation === null || organisation === void 0 ? void 0 : organisation.slug),
        hasRobotsNoIndex: !organisation,
        bodyCN: "px-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrganizationJsonLd, {
                organisation: organisation
            }),
            organisation ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row space-x-4",
                        children: [
                            (organisation === null || organisation === void 0 ? void 0 : organisation.favicon) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: "rounded",
                                    width: 48,
                                    height: 48,
                                    src: "".concat("https://xxshqbqasrbviwgjwzwp.supabase.co", "/storage/v1/object/public/public").concat(organisation === null || organisation === void 0 ? void 0 : organisation.favicon),
                                    alt: "".concat((organisation === null || organisation === void 0 ? void 0 : organisation.name) || "", " logo")
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-center items-center w-12 h-12 rounded bg-gray-100 ",
                                children: organisation === null || organisation === void 0 ? void 0 : (ref1 = organisation.name) === null || ref1 === void 0 ? void 0 : ref1[0]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-4xl font-black",
                                children: orgName
                            })
                        ]
                    }),
                    (organisation === null || organisation === void 0 ? void 0 : organisation.size) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-2 ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "px-1.5 py-1 text-gray-600 bg-gray-100 rounded-sm text-xs font-medium ",
                            children: organisationSizeToLabel/* organisationSizeToLabel */.P[organisation === null || organisation === void 0 ? void 0 : organisation.size]
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-4",
                        children: organisation === null || organisation === void 0 ? void 0 : organisation.about
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-4",
                        children: ((organisation === null || organisation === void 0 ? void 0 : organisation.webUrl) || (organisation === null || organisation === void 0 ? void 0 : organisation.twitterUrl) || (organisation === null || organisation === void 0 ? void 0 : organisation.linkedinUrl) || (organisation === null || organisation === void 0 ? void 0 : organisation.githubUrl)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row mt-2 space-x-4 text-sm",
                            children: [
                                (organisation === null || organisation === void 0 ? void 0 : organisation.webUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: organisation === null || organisation === void 0 ? void 0 : organisation.webUrl,
                                    target: "_blank",
                                    rel: "nofollow noopener noreferrer",
                                    className: "hover:underline",
                                    children: organisation === null || organisation === void 0 ? void 0 : organisation.webUrl
                                }),
                                (organisation === null || organisation === void 0 ? void 0 : organisation.twitterUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: organisation === null || organisation === void 0 ? void 0 : organisation.twitterUrl,
                                    title: "Twitter",
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(twitter/* default */.Z, {
                                        className: "fill-current text-gray-600 hover:text-gray-400 h-5"
                                    })
                                }),
                                (organisation === null || organisation === void 0 ? void 0 : organisation.linkedinUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: organisation === null || organisation === void 0 ? void 0 : organisation.linkedinUrl,
                                    title: "LinkedIn",
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(linkedin/* default */.Z, {
                                        className: "fill-current text-gray-600 hover:text-gray-400 h-5"
                                    })
                                }),
                                (organisation === null || organisation === void 0 ? void 0 : organisation.githubUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: organisation === null || organisation === void 0 ? void 0 : organisation.githubUrl,
                                    title: "GitHub",
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(github/* default */.Z, {
                                        className: "fill-current text-gray-600 hover:text-gray-400 h-5"
                                    })
                                }),
                                (organisation === null || organisation === void 0 ? void 0 : organisation.instagramUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: organisation === null || organisation === void 0 ? void 0 : organisation.instagramUrl,
                                    title: "Instagram",
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(instagram/* default */.Z, {
                                        className: "fill-current text-gray-600 hover:text-gray-400 h-5"
                                    })
                                }),
                                (organisation === null || organisation === void 0 ? void 0 : organisation.youtubeUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: organisation === null || organisation === void 0 ? void 0 : organisation.youtubeUrl,
                                    title: "YouTube",
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube/* default */.Z, {
                                        className: "fill-current text-gray-600 hover:text-gray-400 h-5"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "mt-14 mb-2 text-2xl font-bold",
                        children: [
                            orgName,
                            " jobs for JavaScript developers"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "max-w-prose",
                        children: activeJobPosts.map((jobPost)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostPreview/* JobPostPreview */.n, {
                                jobPost: jobPost,
                                hasOrganisationAbout: false
                            }, jobPost.id))
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-40 text-2xl font-bold text-center",
                children: "Company not found."
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var _slug_ = ((0,tools.withSuperJSONPage)(OrganisationPage));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,8184,3544,2804,5675,7522,4828,7938,9774,2888,179], function() { return __webpack_exec__(93181); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);